var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { Button } from '../Button';
import { Portal } from '../../internal/Portal';
export const Snackbar = (_a) => {
    var { actionName, className, duration = 5000, onActionClick, onClose, portal = true, title } = _a, rest = __rest(_a, ["actionName", "className", "duration", "onActionClick", "onClose", "portal", "title"]);
    const [visible, setVisible] = useState(true);
    const snackbarRef = useRef(null);
    const handleClose = React.useCallback((e) => {
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose(e);
        clearTimeout(snackbarRef === null || snackbarRef === void 0 ? void 0 : snackbarRef.current);
    }, [onClose]);
    useEffect(() => {
        if (duration === null || duration === 0)
            return;
        snackbarRef.current = setTimeout(() => handleClose(), duration);
        return () => clearTimeout(snackbarRef.current);
    }, [duration, handleClose]);
    if (!visible)
        return null;
    const SnackbarClasses = classnames('Snackbar', className, {
        'Snackbar--floating': portal,
    });
    const snackbar = (React.createElement("div", Object.assign({ className: SnackbarClasses, "data-anvil-component": "Snackbar" }, rest),
        title && React.createElement("div", { className: "Snackbar__title" }, title),
        actionName && onActionClick && (React.createElement("div", { onClick: onActionClick, className: "Snackbar__action" }, actionName)),
        onClose && (React.createElement(Button, { "aria-label": "close snackbar", fill: "subtle", className: "Snackbar__close", iconName: "clear", size: "xsmall", onClick: handleClose }))));
    return React.createElement(Portal, { conditional: portal }, snackbar);
};
//# sourceMappingURL=Snackbar.js.map